import { IRevenueSpendByAccountListTableLang } from '../../../types/lang'

export const revenueSpendByAccountListTableLang: IRevenueSpendByAccountListTableLang = {
	revenue_spend_by_account_list_table: {
		column_date: 'Date',
		column_account: 'Account',
		column_team: 'Team',
		column_kt_group: 'KT Group',
		column_revenue_cpa: 'Revenue Cpa',
		column_revenue_offer_spend: 'Revenue Offer Spend',
		column_revenue_total: 'Revenue Total',
		column_spend: 'Spend',
		column_roi: 'ROI, %',
		column_account_fb: 'Accounts FB',
		column_creo: 'Creo',
		column_installs: 'Installs',
		column_slices: 'Slices',
		column_agency_percent: 'Agency percent',
		column_profit: 'Profit'
	}
}